/* eslint-disable */
import React from 'react';

export type MisconceptionCardIconRender = (active: boolean) => React.ReactNode;

export const EMAIL_RISK_ICONS: MisconceptionCardIconRender[] = [
  // 数据库
  (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse
        cx="12"
        cy="5"
        rx="8"
        ry="3"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M4 5v6c0 1.657 3.582 3 8 3s8-1.343 8-3V5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M4 11v6c0 1.657 3.582 3 8 3s8-1.343 8-3v-6"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  ),
  // 归档
  (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="3"
        y="4"
        width="18"
        height="4"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M10 12h4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  // 光圈
  (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M12 3v18M3 12h18M5.636 5.636l12.728 12.728M18.364 5.636L5.636 18.364"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  // 立方体
  (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 16V8a2 2 0 00-1-1.732l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.732l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
];

export const FCG_ICONS: MisconceptionCardIconRender[] = [
  // 网络
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 48.3C8.88268 48.8879 11.5288 50.3105 13.6091 52.3909C15.6895 54.4712 17.1121 57.1173 17.7 60M6 36.15C12.0924 36.8276 17.7728 39.5581 22.1073 43.8927C26.4419 48.2272 29.1724 53.9076 29.85 60M6 24V18C6 16.4087 6.63214 14.8826 7.75736 13.7574C8.88258 12.6321 10.4087 12 12 12H60C61.5913 12 63.1174 12.6321 64.2426 13.7574C65.3679 14.8826 66 16.4087 66 18V54C66 55.5913 65.3679 57.1174 64.2426 58.2426C63.1174 59.3679 61.5913 60 60 60H42M6 60H6.03"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 设备
  (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="3"
        y="4"
        width="18"
        height="7"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="3"
        y="13"
        width="18"
        height="7"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle cx="6" cy="7.5" r="0.75" fill="currentColor" />
      <circle cx="6" cy="16.5" r="0.75" fill="currentColor" />
    </svg>
  ),
  // 眼睛
  (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  // 锁
  (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4"
        y="10"
        width="16"
        height="11"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M8 10V7a4 4 0 1 1 8 0v3"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  ),
];
